import { render, staticRenderFns } from "./FormOwner.vue?vue&type=template&id=1056c054&scoped=true&"
import script from "./FormOwner.vue?vue&type=script&lang=js&"
export * from "./FormOwner.vue?vue&type=script&lang=js&"
import style0 from "./FormOwner.vue?vue&type=style&index=0&id=1056c054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1056c054",
  null
  
)

export default component.exports